var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenedMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.982 20.457C4.969 23.394 7.975 26.575 12 30C16.026 26.576 19.0325 23.395 21.0195 20.457C23.0065 17.519 24 14.8 24 12.3C24.002 8.55 22.796 5.5625 20.382 3.3375C17.968 1.1125 15.174 0 12 0C8.826 0 6.0325 1.1125 3.6195 3.3375C1.2065 5.5625 0 8.55 0 12.3C0.001 14.801 0.995 17.52 2.982 20.457ZM6.4966 9.531V18.4618H17.5735V9.531L18.9235 6.58869L17.6774 6.00023L16.0504 9.49638H8.01968L6.39276 6.00023L5.1466 6.58869L6.4966 9.531Z",
    fill: "#378114"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6504 13.6156H13.4197C13.6158 13.6156 13.7804 13.5491 13.9133 13.4162C14.0462 13.2833 14.1124 13.119 14.112 12.9233C14.1115 12.7276 14.0451 12.5633 13.9126 12.4304C13.7801 12.2975 13.6158 12.231 13.4197 12.231H10.6504C10.4543 12.231 10.29 12.2975 10.1575 12.4304C10.0251 12.5633 9.9586 12.7276 9.95814 12.9233C9.95768 13.119 10.0241 13.2835 10.1575 13.4169C10.2909 13.5503 10.4552 13.6165 10.6504 13.6156Z",
    fill: "#378114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedMarker);
export default __webpack_public_path__ + "static/media/opened-marker.20bd21db3f3a22093198d94f1c3443c5.svg";
export { ForwardRef as ReactComponent };